"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const react_native_1 = require("react-native");
const loanApplicationSlice_1 = require("../loanApplicationSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const store_1 = require("../../../store");
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const input_1 = __importStar(require("../../../components/input/input"));
const choices_1 = require("../../../utils/choices");
const utils_1 = require("../../../utils/utils");
const constants_1 = require("../../../constants/constants");
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const summaryBox_1 = __importDefault(require("../../../components/summaryRow/summaryBox"));
const text_1 = __importStar(require("../../../components/text/text"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const analytics_1 = require("../../../utils/analytics/analytics");
const LoanApplicationSummaryEditableFields = ({ loanApplication, loanApplicationId, loanTerms, errors, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const navigation = (0, useAppNavigation_1.default)();
    const screenWidth = react_native_1.Dimensions.get('window').width;
    const [summaryLoanAmount, setLoanAmount] = (0, react_1.useState)(loanApplication.request_amount);
    const [summaryLoanReason, setLoanReason] = (0, react_1.useState)(loanApplication.use_of_proceeds);
    const [summaryTenor, setTenor] = (0, react_1.useState)(loanApplication.request_tenor_days);
    const [summaryPeriodicity, setPeriodicity] = (0, react_1.useState)(loanApplication.request_repayment_periodicity);
    const [summaryCanProvideCheque, setCanProvideCheque] = (0, react_1.useState)(loanApplication.can_provide_cheque);
    const [showEdit, setShoWEdit] = (0, react_1.useState)(false);
    const [errorsLocal, setErrorsLocal] = (0, react_1.useState)(errors);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const initialLoanAmount = loanApplication.request_amount;
    const submitLoanApplicationSummary = async () => {
        setIsLoading(true);
        const payload = {
            use_of_proceeds: summaryLoanReason,
            request_amount: typeof summaryLoanAmount === 'boolean' ? -1 : summaryLoanAmount,
            request_tenor_days: summaryTenor,
            request_repayment_periodicity: summaryPeriodicity,
            can_provide_cheque: summaryCanProvideCheque,
            loanApplicationId,
        };
        const result = await dispatch((0, loanApplicationSlice_1.editLoanApplicationSummary)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'edit_loan_application',
            status: 'submitted',
            location: 'screen_LoanApplicationSummaryEditableFields',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'edit_loan_application',
                status: 'success',
                location: 'screen_LoanApplicationSummaryEditableFields',
            });
            setIsLoading(false);
            navigation.navigate(screenConstants_1.HOME_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'edit_loan_application',
                status: 'fail',
                location: 'screen_LoanApplicationSummaryEditableFields',
            });
            setErrorsLocal(result.payload);
            setIsLoading(false);
        }
    };
    const summaryData = [
        {
            field: 'Loan Amount',
            fieldName: 'loanAmount',
            value: loanApplication.request_amount,
        },
        {
            field: 'Reason of Loan',
            value: Number(loanApplication.use_of_proceeds),
            fieldName: 'loanReason',
        },
        {
            field: 'Tenor Days',
            value: Number(loanApplication.request_tenor_days),
            fieldName: 'tenor',
        },
        {
            field: 'Payment Periodicity',
            value: Number(loanApplication.request_repayment_periodicity),
            fieldName: 'periodicity',
        },
        {
            field: 'Can Provide Cheques',
            value: loanApplication.can_provide_cheque === true ? 'Yes' : 'No',
            fieldName: 'canProvideCheque',
        },
    ];
    return (react_1.default.createElement(navContainer_1.default, { errors: errorsLocal, isLoading: isLoading, childrenTitle: "Loan Summary", footer: showEdit ? (react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Save", onPress: submitLoanApplicationSummary, eventName: "tap_loan_app_submit_edit" })) : (react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Edit", onPress: () => setShoWEdit(true), eventName: "tap_loan_app_edit" })) },
        showEdit ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_SLIDER, minimumValue: constants_1.MINIMUM_LOAN_VALUE, maximumValue: constants_1.MAXIMUM_LOAN_VALUE, value: summaryLoanAmount, setValue: setLoanAmount, symbol: constants_1.NAIRA_SYMBOL, step: constants_1.LOAN_AMOUNT_STEP, error: (0, utils_1.getError)('request_amount', errors), label: "How much do you need?" }),
            react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.centerChildHorizontalVertical,
                    screenWidth < constants_1.BREAK_POINT_WIDTH
                        ? { bottom: 10, marginBottom: 20 }
                        : { bottom: 30, marginBottom: 10 },
                ] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, color: colors_1.default.COLOR_PRIMARY }, `(Current amount: ${constants_1.NAIRA_SYMBOL} ${(0, utils_1.formatNumber)(initialLoanAmount)})`)),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.loanReasonChoices, label: "Why do you need the loan?", setValue: setLoanReason, value: summaryLoanReason, error: (0, utils_1.getError)('use_of_proceeds', errors), required: true }),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "How long do you need it for?", choices: choices_1.lengthChoices, setValue: setTenor, value: summaryTenor, error: (0, utils_1.getError)('request_tenor_days', errors), required: true }),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "How often would you like to repay?", choices: choices_1.periodicityChoices, setValue: setPeriodicity, value: summaryPeriodicity, error: (0, utils_1.getError)('request_repayment_periodicity', errors), required: true }),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Can you issue a cheque to secure your loan?", choices: choices_1.yesNoChoicesBoolean, setValue: setCanProvideCheque, value: summaryCanProvideCheque, error: (0, utils_1.getError)('can_provide_cheque', errors), required: true }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(summaryBox_1.default, { title: "Summary", data: summaryData }))),
        loanTerms && react_1.default.createElement(summaryBox_1.default, { title: "Loan Terms", data: loanTerms })));
};
LoanApplicationSummaryEditableFields.defaultProps = {
    loanApplicationId: undefined,
    errors: undefined,
    loanTerms: undefined,
};
exports.default = LoanApplicationSummaryEditableFields;
